import PropTypes from 'prop-types';
import { numberFormat, unitToString } from '@/utils/unitUtils';

const Kpi = ({ label, value, unit, hint }) => (
  <div className="flex flex-col gap-0.5">
    <div className="text-[11px] text-gray-500">{label}</div>
    <div className="flex items-baseline gap-1">
      <span className="text-base font-semibold text-gray-900 tabular-nums">{value}</span>
      {unit && <span className="text-xs text-gray-500">{unit}</span>}
    </div>
  </div>
);

Kpi.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  unit: PropTypes.string,
};

const InvestmentHeadline = ({ kpis, nodeLabel, lcohUnit }) => {
  const npv = kpis?.npv;
  const irrReal = kpis?.irrReal;
  const payback = kpis?.payback;
  const lcoh = kpis?.lcoh;

  const npvValue = npv ? numberFormat(npv.scalar, 0) : '—';
  const npvUnit = npv ? unitToString(npv.unit) : null;

  const paybackValue = payback ? numberFormat(payback.scalar, 1) : 'Beyond horizon';
  const paybackUnit = payback ? 'years' : null;
  const lcohValue = lcoh != null ? numberFormat(lcoh, 2) : '—';

  return (
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 py-4 border-b border-gray-200">
      <div className="flex flex-col gap-0.5">
        <div className="text-xs uppercase tracking-wide text-gray-500">
          Net present value{nodeLabel ? ` · ${nodeLabel}` : ''}
        </div>
        <div className="flex items-baseline gap-2">
          <span className="text-4xl font-semibold text-gray-900 tabular-nums">{npvValue}</span>
          {npvUnit && <span className="text-base text-gray-500">{npvUnit}</span>}
        </div>
      </div>
      <div className="grid grid-cols-3 gap-x-10 gap-y-2">
        <Kpi
          label="After-tax real IRR"
          value={irrReal ? numberFormat(irrReal.scalar, 2) : '—'}
          unit={irrReal ? '%' : null}
        />
        <Kpi label="Payback period" value={paybackValue} unit={paybackUnit} />
        <Kpi label="Levelized cost" value={lcohValue} unit={lcohUnit} />
      </div>
    </div>
  );
};

InvestmentHeadline.propTypes = {
  kpis: PropTypes.object,
  nodeLabel: PropTypes.string,
  lcohUnit: PropTypes.string,
};

export default InvestmentHeadline;
